import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";

import { Container, Head, Avatar, Close, Settings } from "./styles.js";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import socket from "../../../services/io";

import AuthActions from "../../../storeChat/ducks/auth";
import UsersActions from "../../../storeChat/ducks/users";
import ChatActions from "../../../storeChat/ducks/chat";
import MessageActions from "../../../storeChat/ducks/messages";

import AvatarImg from "../../../assets/avatar-anonimo.png";

class Users extends Component {
  state = {
    search: ""
  };

  componentDidMount() {
    if (this.props.auth.user._id) {
      socket.emit("add user to connected", this.props.auth.user._id);
      socket.emit("add user pending room", this.props.auth.user._id);
      this.getPendingMessages();
    }

    socket.on("user joined", users => {
      this.props.setUsersOnline(users);
    });

    socket.on("user left", users => {
      this.props.setUsersOnline(users);
    });

    socket.on("new pending message", data => {
      this.getPendingMessages();
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.auth.user._id &&
      prevProps.auth.user._id !== this.props.auth.user._id
    ) {
      socket.emit("add user to connected", this.props.auth.user._id);
      socket.emit("add user pending room", this.props.auth.user._id);
      this.getPendingMessages();
    }
  }

  handleInitChat = user => {
    this.props.getMessages(
      this.props.auth.user._id,
      user._id,
      this.props.auth.user.customer.key,
      25
    );

    this.props.openChat(
      this.props.auth.user._id,
      user._id,
      this.props.auth.user.customer.key,
      user.name,
      user.avatar,
      this.props.chat.channels.filter(
        channel =>
          channel ===
          `${this.props.auth.user._id}${user._id}${
            this.props.auth.user.customer.key
          }`
      ).length === 0
    );
  };

  getPendingMessages = () => {
    this.props.getPendingMessages(
      this.props.auth.user._id,
      this.props.auth.user._id,
      this.props.auth.user.customer.key
    );
  };

  render() {
    return (
      <Container>
        <Close
          onClick={() => {
            document
              .getElementById("chat-container")
              .classList.add("minimizado");
          }}
        >
          <i className="fas fa-chevron-circle-right" />
        </Close>
        {this.props.master ? (
          <a
            href={`https://chat-2a391.web.app/login?${localStorage
              .getItem("@chat-app:token")
              .replace("Bearer ", "")}`}
            target="_blank"
          >
            <Settings>
              <i className="fas fa-cogs" />
            </Settings>
          </a>
        ) : (
          ""
        )}

        <Head>
          <input
            type="text"
            placeholder="Buscar usuário"
            onChange={e =>
              this.setState({
                search: e.target.value
              })
            }
          />
        </Head>
        <Scrollbars>
          <ul>
            {this.props.users
              .filter(user => user._id !== this.props.auth.user._id)
              .filter(user => {
                return user.name
                  .toLowerCase()
                  .includes(this.state.search.toLowerCase());
              })
              .sort((a, b) => {
                if (a.name > b.name) {
                  return 1;
                }

                if (a.name < b.name) {
                  return -1;
                }

                return 0;
              })
              .sort((a, b) => {
                if (
                  this.props.chat.users_online.filter(id => id === a._id)
                    .length >
                  this.props.chat.users_online.filter(id => id === b._id).length
                ) {
                  return -1;
                }

                if (
                  this.props.chat.users_online.filter(id => id === a._id)
                    .length <
                  this.props.chat.users_online.filter(id => id === b._id).length
                ) {
                  return 1;
                }

                return 0;
              })
              .sort((a, b) => {
                const arrayA = this.props.messages.filter(
                  message =>
                    message.id_from === a._id &&
                    message.id_to === this.props.auth.user._id
                );

                const arrayB = this.props.messages.filter(
                  message =>
                    message.id_from === b._id &&
                    message.id_to === this.props.auth.user._id
                );

                if (arrayA.length > arrayB.length) {
                  return -1;
                }

                if (arrayA.length < arrayB.length) {
                  return 1;
                }

                return 0;
              })

              .map(user => (
                <li
                  key={user._id}
                  onClick={() => this.handleInitChat(user)}
                  className={
                    this.props.chat.id_to === user._id ? "selected" : ""
                  }
                >
                  <Avatar>
                    {user.avatar ? (
                      <img src={user.avatar} alt={`Avatar ${user.name}`} />
                    ) : (
                      <img src={AvatarImg} alt={`Avatar ${user.name}`} />
                    )}
                  </Avatar>

                  <h2>
                    {user.name}
                    <small
                      className={
                        this.props.chat.users_online.includes(user._id)
                          ? "online"
                          : "offline"
                      }
                    >
                      {this.props.chat.users_online.includes(user._id)
                        ? "Online"
                        : "Offline"}
                    </small>
                  </h2>
                  {this.props.messages.filter(
                    message =>
                      message.id_from === user._id &&
                      message.id_to === this.props.auth.user._id
                  ).length > 0 && (
                    <p className="pending-messages">
                      {
                        this.props.messages.filter(
                          message =>
                            message.id_from === user._id &&
                            message.id_to === this.props.auth.user._id
                        ).length
                      }
                    </p>
                  )}
                </li>
              ))}
          </ul>
        </Scrollbars>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  users: state.users.users,
  chat: state.chat,
  messages: state.messages.pendingMessages
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...AuthActions,
      ...UsersActions,
      ...ChatActions,
      ...MessageActions
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);



// WEBPACK FOOTER //
// ./src/components/ChatContainer/Users/index.js